/* eslint-disable */
export default {
  en: {
  	UI: {
  		name: 'Periodic Table',
  		star: 'star',
  		loading: 'Loading Periodic Table :)',
  		mode:{
  			dark:'Dark Mode',
  			light:'Light Mode'
  		},

	    lang: {
	    	tr: 'Turkish',
	    	en: 'English'
	    }
  	},
    element: {
    	molar: 'Atom Mass',
    	number: 'Atom Number',
    },
    types: [
  		'Types',
      'Ametal',
      'Alkali Metal',
      'Alkaline Earth Metal',
      'Transition Metal',
      'Metal',
      'Half Metal',
      'Halogen',
      'Inert gas',
      'Lantanide',
      'Actinide'
    ]
  },
  tr: {
  	UI: {
  		name: 'Düzenli Çizelge',
  		star: 'Yıldızla',
  		loading: 'Düzenli Çizelge Yükleniyor :)',
  		mode:{
  			dark: 'Koyu Görünüm',
  			light: 'Aydınlık Görünüm'
  		},
	    lang: {
	    	tr: 'Türkçe',
	    	en: 'İngilizce'
	    }
  	},
    element: {
    	molar: 'Atom Kütlesi',
    	number: 'Atom Dizini',
    },
  	types: [
  		'Türler',
      'Ametal',
      'Alkali Metal',
      'Alkali Toprak Metal',
      'Geçiş Metali',
      'Metal',
      'Yarı Metal',
      'Halojen',
      'Soygaz',
      'Lantanit',
      'Aktinit'
    ]
  }
}